var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup162(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 61,
    viewBox: "0 0 54 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.56235 43.3852V47.6709M4.56235 51.9566V47.6709M4.56235 47.6709H49.4374V43.3852V51.9566M25.5366 38.5638H5.5379V32.1352M25.5366 38.5638V43.3852M25.5366 38.5638V32.1352L24.0732 32.1352M25.5366 43.3852H1.14795C1.14795 43.3852 1.14795 23.5641 1.14795 20.3495C1.14795 17.1349 5.5379 17.135 5.5379 20.3495C5.5379 21.5986 5.5379 23.6567 5.5379 25.7063M25.5366 43.3852H47.9741M5.5379 32.1352C5.5379 32.1352 5.5379 28.9312 5.5379 25.7063M5.5379 32.1352L15.2933 32.1349M47.9741 26.2424C47.9741 29.4566 47.9741 43.3852 47.9741 43.3852M47.9741 26.2424C47.9743 23.0284 52.364 23.0282 52.364 26.2424C52.364 29.4566 52.364 43.3852 52.364 43.3852H47.9741M47.9741 26.2424L46.9985 26.242C32.3654 25.7063 26.4407 25.9864 24.0732 32.1352M5.5379 25.7063C11.4513 26.3998 13.3178 28.04 15.2933 32.1349M15.2933 32.1349L24.0732 32.1352M24.561 4.81348V18.742M18.22 11.7778H30.902",
    stroke: "#006D77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0737 1.52783C29.3616 1.52811 33.8042 6.26706 33.8042 12.314C33.804 18.3607 29.3615 23.0988 24.0737 23.0991C18.7857 23.0991 14.3425 18.3608 14.3423 12.314C14.3423 6.26689 18.7856 1.52783 24.0737 1.52783Z",
    stroke: "#006D77",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5625 52.9565C6.0791 52.9566 7.46484 54.3378 7.46484 56.2427C7.46464 58.1473 6.07899 59.5277 4.5625 59.5278C3.04595 59.5278 1.66036 58.1474 1.66016 56.2427C1.66016 54.3377 3.04584 52.9565 4.5625 52.9565Z",
    stroke: "#006D77",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.438 52.9565C50.9546 52.9566 52.3403 54.3378 52.3403 56.2427C52.3401 58.1473 50.9545 59.5277 49.438 59.5278C47.9214 59.5278 46.5358 58.1474 46.5356 56.2427C46.5356 54.3377 47.9213 52.9565 49.438 52.9565Z",
    stroke: "#006D77",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup162);
export default __webpack_public_path__ + "static/media/Group 162.54b7a5ee24f4a10d2eda3546f44ed993.svg";
export { ForwardRef as ReactComponent };